import { render, staticRenderFns } from "./yuerbliangting.vue?vue&type=template&id=5ba0c6a4&scoped=true&"
import script from "./yuerbliangting.vue?vue&type=script&lang=js&"
export * from "./yuerbliangting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba0c6a4",
  null
  
)

export default component.exports